function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Concat from 'concat-typed-array';
var Buffer = /*#__PURE__*/function () {
  function Buffer(buffer) {
    _classCallCheck(this, Buffer);
    this.buffer = buffer || new Uint8Array(0);
  }
  _createClass(Buffer, [{
    key: "write",
    value: function write() {
      var _this = this;
      for (var _len = arguments.length, buffer = new Array(_len), _key = 0; _key < _len; _key++) {
        buffer[_key] = arguments[_key];
      }
      buffer.forEach(function (item) {
        _this.buffer = Concat(Uint8Array, _this.buffer, item);
      });
    }
  }], [{
    key: "writeUint32",
    value: function writeUint32(value) {
      return new Uint8Array([value >> 24, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff]);
    }
  }, {
    key: "readAsInt",
    value: function readAsInt(arr) {
      var temp = '';
      function padStart4Hex(hexNum) {
        var hexStr = hexNum.toString(16);
        return hexStr.padStart(2, '0');
      }
      arr.forEach(function (num) {
        temp += padStart4Hex(num);
      });
      return parseInt(temp, 16);
    }
  }]);
  return Buffer;
}();
export default Buffer;